import { AllClosingDaysV2, ApplyToType } from '../types/location.types';
import { PaginationParams, ResponseType } from '../types/shared.types';
import { api } from './api';

export const createClosingDay = (data: {
  from: string;
  to: string;
  locationId?: number | null;
  brandId?: number | null;
  applyTo?: ApplyToType;
}) => api.post<ResponseType<null>>(`/v2/closing-days`, data);

export const getAllClosingDays = (
  params: PaginationParams<{
    locationId: number;
    brandId: number | null;
  }>
) =>
  api.get<
    ResponseType<AllClosingDaysV2>
  >(`/v2/closing-days`, { params });

export const deleteClosingDay = (id: string | number) =>
  api.delete<ResponseType<null>>(`/v2/closing-days/${id}`);
